import 'react-loading-skeleton/dist/skeleton.css';
import { Route, BrowserRouter as Router, Switch } from "react-router-dom";
import "./styles/app.sass";

import Page from "./components/Page";
import AffiliateCenter from "./screens/AffiliateCenter";
import Comments from "./screens/Comments";
import CustomerList from "./screens/CustomerList";
import Customers from "./screens/Customers";
import Drafts from "./screens/Drafts";
import Earning from "./screens/Earning";
import ExploreContributors from "./screens/ExploreContributors";
import Farming from "./screens/Farming";
import Home from "./screens/Home";
import HomeOld from "./screens/HomeOld";
import IconList from "./screens/IconList";
// import LeadBoards from "./screens/LeadBoards";
import MessageCenter from "./screens/MessageCenter";
import NewProduct from "./screens/NewProduct";
import Notification from "./screens/Notification";
// import ProductsDashboard from "./screens/ProductsDashboard";
import Profile from "./screens/Profile";
import Promote from "./screens/Promote";
import Questions from "./screens/Questions";
import Refunds from "./screens/Refunds";
import Released from "./screens/Released";
import Scheduled from "./screens/Scheduled";
import Settings from "./screens/Settings";
import SignIn from "./screens/SignIn";
import SignUp from "./screens/SignUp";
import Statements from "./screens/Statements";
import UpgradeToPro from "./screens/UpgradeToPro";
import Withdrawals from "./screens/Withdrawals";
import { useLocalStorage } from "./customHooks/useLocalStorage";
import Archive from "./screens/Home/Archive";
// import JoinNetwork from "./screens/PointsCenter/JoinNetwork";
import { HOME_TITLE, CASPER_SWITCH } from "./utils/config";
import { CiVault } from "react-icons/ci";
import LiquidStaking from './screens/LiquidStaking';
import Kado from './screens/Kado';

function App() {

    useLocalStorage();

    return (
        <Router>
            <AppContent />
        </Router>
    );
}

function AppContent() {
    return (
        <Switch>
            <Route
                exact
                path="/"
                render={() => (
                    <Page title={HOME_TITLE} icon="home">
                        <Home />
                    </Page>
                )}
            />
            <Route
                exact
                path="/wallet/:id"
                render={() => (
                    <Page title="Wise Lending" icon="home">
                        <Home />
                    </Page>
                )}
            />
            <Route
                exact
                path="/nft/:nftId"
                render={() => (
                    <Page title="Wise Lending" icon="home">
                        <Home />
                    </Page>
                )}
            />
            <Route
                exact
                path="/archive"
                render={() => (
                    <Page title="Archive Pools" icon="schedule">
                        <Archive />
                    </Page>
                )}
            />
            <Route
                exact
                path="/old"
                render={() => (
                    <Page title="Example">
                        <HomeOld />
                    </Page>
                )}
            />
            {/*<Route
                exact
                path="/products/dashboard"
                render={() => (
                    <Page title="Points Center">
                        <ProductsDashboard />
                    </Page>
                )}
            />
            <Route
                exact
                path="/points-v1"
                render={() => (
                    <Page title="Points Center" icon="diamond">
                        <PointsCenter />
                    </Page>
                )}
            />
            <Route
                exact
                path="/points"
                render={() => (
                    <Page title="Leaderboards" icon="diamond">
                        <LeadBoards />
                    </Page>
                )}
            />
            <Route
                exact
                path="/r/:address"
                render={() => (
                    <Page
                        title="New Referral Invitation"
                        mobileTitle="Referral Invitation"
                        icon="share"
                    >
                        <JoinNetwork />
                    </Page>
                )}
            />*/}
            <Route
                exact
                path="/r/:address"
                render={() => (
                    <Page title={HOME_TITLE} icon="home">
                        <Home />
                    </Page>
                )}
            />
            <Route
                exact
                path="/points"
                render={() => (
                    <Page title={HOME_TITLE} icon="home">
                        <Home />
                    </Page>
                )}
            />
            <Route
                exact
                path="/products/add"
                render={() => (
                    <Page title="New page">
                        <NewProduct />
                    </Page>
                )}
            />
            <Route
                exact
                path="/products/drafts"
                render={() => (
                    <Page title="Drafts">
                        <Drafts />
                    </Page>
                )}
            />
            <Route
                exact
                path="/products/released"
                render={() => (
                    <Page title="Released">
                        <Released />
                    </Page>
                )}
            />
            <Route
                exact
                path="/products/comments"
                render={() => (
                    <Page title="Comments">
                        <Comments />
                    </Page>
                )}
            />
            <Route
                exact
                path="/products/scheduled"
                render={() => (
                    <Page title="Scheduled">
                        <Scheduled />
                    </Page>
                )}
            />
            <Route
                exact
                path="/farming"
                render={() => (
                    <Page title="Power Farms" icon="store">
                        <Farming />
                    </Page>
                )}
            />
            <Route
                exact
                path="/liquid-staking"
                render={() => {
                    if (!CASPER_SWITCH) {
                        window.location.href = '/';
                        return null;
                    }
                    return (
                        <Page>
                            <LiquidStaking/>
                        </Page>
                    );
                }}
            />
            <Route
                exact
                path="/RWAvaults"
                render={() => (
                    <Page title="RWA Vaults" reactIcon={<CiVault size={32} style={{ strokeWidth: .8 }} />}>
                        <Farming />
                    </Page>
                )}
            />
            <Route
                exact
                path="/customers/overview"
                render={() => (
                    <Page title="Analytics">
                        <Customers />
                    </Page>
                )}
            />
            <Route
                exact
                path="/customers/customer-list"
                render={() => (
                    <Page title="List View">
                        <CustomerList />
                    </Page>
                )}
            />
            <Route
                exact
                path="/profile"
                render={() => (
                    <Page wide>
                        <Profile />
                    </Page>
                )}
            />
            <Route
                exact
                path="/details"
                render={() => (
                    <Page title="Details Overview" icon="bar-chart">
                        <Earning />
                    </Page>
                )}
            />
            <Route
                exact
                path="/liquidations"
                render={() => (
                    <Page title="Liquidation">
                        <Refunds />
                    </Page>
                )}
            />
            <Route
                exact
                path="/withdrawals"
                render={() => (
                    <Page title="Withdrawals">
                        <Withdrawals />
                    </Page>
                )}
            />
            <Route
                exact
                path="/statements"
                render={() => (
                    <Page title="Statements">
                        <Statements />
                    </Page>
                )}
            />
            <Route
                exact
                path="/promote"
                render={() => (
                    <Page title="LiquidNFTs Details" icon="promotion">
                        <Promote />
                    </Page>
                )}
            />
            <Route
                exact
                path="/notification"
                render={() => (
                    <Page title="Notification">
                        <Notification />
                    </Page>
                )}
            />
            <Route
                exact
                path="/settings"
                render={() => (
                    <Page title="Local Settings" icon="setting">
                        <Settings />
                    </Page>
                )}
            />
            <Route
                exact
                path="/sign-in"
                render={() => (
                    <Page title="Sign In">
                        <SignIn />
                    </Page>
                )}
            />
            <Route
                exact
                path="/sign-up"
                render={() => (
                    <Page title="Sign Up">
                        <SignUp />
                    </Page>
                )}
            />
            <Route
                exact
                path="/questions"
                render={() => (
                    <Page title="Questions">
                        <Questions />
                    </Page>
                )}
            />
            <Route
                exact
                path="/icon-list"
                render={() => (
                    <Page title="Icon List">
                        <IconList />
                    </Page>
                )}
            />
            <Route
                exact
                path="/message-center"
                render={() => (
                    <Page title="Message Center">
                        <MessageCenter />
                    </Page>
                )}
            />
            <Route
                exact
                path="/explore-contributors"
                render={() => (
                    <Page title="Explore Contributors">
                        <ExploreContributors />
                    </Page>
                )}
            />
            <Route
                exact
                path="/affiliate-center"
                render={() => (
                    <Page title="Affiliate Center">
                        <AffiliateCenter />
                    </Page>
                )}
            />
            <Route
                exact
                path="/kado"
                render={() => (
                    <Page title="Kado">
                        <Kado />
                    </Page>
                )}
            />
            <Route
                exact
                path="/upgrade-to-pro"
                render={() => (
                    <Page title="Upgrade to Pro">
                        <UpgradeToPro />
                    </Page>
                )}
            />
        </Switch>
    );
}

export default App;
